import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function DiceRoll() {
  const [you, setYou] = useState(null);
  const [house, setHouse] = useState(null);
  const [rolling, setRolling] = useState(false);
  const [result, setResult] = useState(null);
  const { refreshMe } = useAuth();

  const roll = async () => {
    setRolling(true); setResult(null);
    const interval = setInterval(() => {
      setYou([Math.ceil(Math.random()*6), Math.ceil(Math.random()*6)]);
      setHouse([Math.ceil(Math.random()*6), Math.ceil(Math.random()*6)]);
    }, 80);
    setTimeout(async () => {
      clearInterval(interval);
      const y = [Math.ceil(Math.random()*6), Math.ceil(Math.random()*6)];
      const h = [Math.ceil(Math.random()*6), Math.ceil(Math.random()*6)];
      setYou(y); setHouse(h);
      const yourSum = y[0] + y[1];
      const houseSum = h[0] + h[1];
      const won = yourSum > houseSum;
      const draw = yourSum === houseSum;
      setResult(draw ? "draw" : won ? "win" : "lose");
      setRolling(false);
      try {
        await api.post("/games/result", { game_slug: "diceroll", won });
        if (won) refreshMe();
      } catch {}
    }, 900);
  };

  const Die = ({ n, color }) => (
    <div className="w-16 h-16 rounded-md flex items-center justify-center text-3xl font-black border-2"
      style={{ background: "#0c0c0e", borderColor: color, color }}>
      {n ?? "?"}
    </div>
  );

  return (
    <div data-testid="game-diceroll" className="bg-black/60 border border-white/10 rounded-md p-6 max-w-md mx-auto text-center">
      <div className="sc-heading text-2xl font-bold mb-2">High Roller</div>
      <div className="text-xs text-zinc-400 mb-6">Roll 2 dice vs the house. Highest total wins.</div>
      <div className="grid grid-cols-2 gap-6 mb-6">
        <div>
          <div className="sc-label mb-2">You</div>
          <div className="flex gap-2 justify-center">
            <Die n={you?.[0]} color="#FF3366" />
            <Die n={you?.[1]} color="#FF3366" />
          </div>
          <div className="text-2xl font-black mt-3" style={{ color: "#FF3366" }}>{you ? you[0]+you[1] : "—"}</div>
        </div>
        <div>
          <div className="sc-label mb-2">House</div>
          <div className="flex gap-2 justify-center">
            <Die n={house?.[0]} color="#00E5FF" />
            <Die n={house?.[1]} color="#00E5FF" />
          </div>
          <div className="text-2xl font-black mt-3" style={{ color: "#00E5FF" }}>{house ? house[0]+house[1] : "—"}</div>
        </div>
      </div>
      {result === "win" && <div className="text-[#10B981] font-bold mb-4">You win!</div>}
      {result === "lose" && <div className="text-[#FF3366] font-bold mb-4">House wins</div>}
      {result === "draw" && <div className="text-[#F59E0B] font-bold mb-4">Push (tie)</div>}
      <button data-testid="diceroll-roll" disabled={rolling} onClick={roll} className="sc-btn w-full">{rolling ? "Rolling..." : "Roll Dice"}</button>
    </div>
  );
}
